import React, { useCallback, useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";

import { STATUS } from "../../../../constants";

const { FAILED } = STATUS;

const CustomTimePickerModal = ({ isModalOpen, dispatch }) => {
  const [timePickerStatus, setTimePickerStatus] = useState(STATUS.DEFAULT);
  const [startTime, setStartTime] = useState(moment());
  const [endTime, setEndTime] = useState(moment());

  const closeModal = useCallback(() => dispatch({ type: "toggleModal", isOpen: false }), [dispatch]);

  const handleClickOk = useCallback(() => {
    if (endTime?.isAfter(startTime)) {
      dispatch({ type: "toggleModal", isOpen: false });
      dispatch({ type: "updateDateRange", startTime, endTime });
      dispatch({ type: "selectTimeRange", rangeType: "custom", isDropDownOpen: false });
      return;
    }
    setTimePickerStatus(FAILED);
  }, [endTime, startTime, dispatch]);

  return (
    <div className={`modal${isModalOpen ? " is-active" : ""}`}>
      <div className="modal-background" />
      <div className="modal-content">
        <div className="card is-radiusless is-small">
          <div className="card-content is-radiusless is-small">
            <div className="content">
              <div className="media-content">
                <p className="menu-label">Report Time Range</p>
                <div className="is-flex is-justify-content-space-between">
                  <div>
                    <p className="is-size-7">Start Time</p>
                    <DatePicker
                      style={{ width: "50%" }}
                      selected={startTime?.toDate()}
                      onChange={(value) => setStartTime(moment(value))}
                    />
                  </div>

                  <div>
                    <p className="is-size-7">End Time</p>
                    <DatePicker selected={endTime?.toDate()} onChange={(value) => setEndTime(moment(value))} />
                  </div>
                </div>
              </div>
            </div>
            {timePickerStatus === FAILED && (
              <article className="message is-danger">
                <div className="message-body is-size-7">End date should be after the start date</div>
              </article>
            )}
          </div>
          <footer className="modal-card-foot">
            <button className="button is-success is-radiusless is-small" onClick={handleClickOk}>
              Ok
            </button>
            <button className="button is-radiusless is-small" onClick={closeModal}>
              Cancel
            </button>
          </footer>
        </div>
      </div>
      <button className="modal-close is-large is-radiusless is-small" aria-label="close" onClick={closeModal} />
    </div>
  );
};

export default CustomTimePickerModal;
